import React, { memo, useState } from 'react';
import classNames from 'classnames';
import Spinner from '../Spinner';
import makeBodyText from '../../utils/makeText';
import makeIconName from '../../utils/makeIconName';
import { ICONS } from '../../constants/icons';
import styles from './index.module.scss';
const BlogPost = memo(({ tag, isFullWidth, title, description, imageSrc, imageAlt, linkHref, linkLabel }) => {
    const [imageLoadStatus, setImageLoadStatus] = useState(false);
    const handleImageLoaded = () => setImageLoadStatus(true);
    const classes = classNames({
        [styles.blogPostWrap]: true,
        [styles.fullWidth]: isFullWidth,
        [makeBodyText('L')]: true,
        [styles.link]: true
    });
    return (React.createElement("a", { target: '_self', href: linkHref, className: classes },
        React.createElement("div", { className: styles.imageWrap },
            React.createElement("div", { className: styles.captionWrap },
                React.createElement("span", { className: makeBodyText('S') },
                    React.createElement("strong", null, tag.toUpperCase()))),
            React.createElement("img", { className: styles.imagePlaceholder, src: imageSrc, alt: imageAlt || title, onLoad: handleImageLoaded, loading: 'lazy', title: title }),
            React.createElement("div", { className: styles.imageBcg, style: imageLoadStatus ? { backgroundImage: `url(${imageSrc})` } : {} }, !imageLoadStatus && React.createElement(Spinner, { color: 'blue' }))),
        React.createElement("div", { className: styles.title },
            React.createElement("strong", null, title)),
        React.createElement("p", { className: `${makeBodyText('XL')} ${styles.text}` }, description),
        React.createElement("div", { className: styles.readMe },
            React.createElement("strong", null, linkLabel || 'Read More'),
            React.createElement("i", { className: `${makeIconName(ICONS.x16.arrow_right, 'x16')} ${styles.icon}` }))));
});
BlogPost.displayName = 'BlogPost';
export default BlogPost;
